type BlogPostDateFields = {
  displayDate?: string | null;
  date?: string | null;
  updatedAt?: string | null;
};

/** CMS required "Date" field first; optional publication `displayDate` next; then Payload `updatedAt`. */
export const getBlogPostDisplayDate = (post: BlogPostDateFields): string | undefined => {
  const value = post.date || post.displayDate || post.updatedAt;
  return value || undefined;
};

/** Show "Last updated on" only when there is no editor-set date and we fall back to `updatedAt`. */
export const shouldShowBlogPostLastUpdatedLabel = (post: BlogPostDateFields): boolean =>
  !(post.date || post.displayDate) && !!post.updatedAt;
